import React from 'react';

import styled, { type DefaultTheme } from 'styled-components';

import media from 'apps/auth/theme/media';

type LogoColor = 'darkGray' | 'lightGray' | 'purple' | 'white' | 'red';

interface LogoProps {
    color?: LogoColor;
    width?: string;
    height?: string;
}

type LogoTheme = DefaultTheme & {
    black?: string;
    purple_100?: string;
    grey_40_lc?: string;
    white_base?: string;
    pink_100?: string;
};

const getLogoColor = (props: { color?: LogoColor; theme: LogoTheme }) => {
    switch (props.color) {
        case 'darkGray':
            return props.theme.black;
        case 'purple':
            return props.theme.purple_100;
        case 'lightGray':
            return props.theme.grey_40_lc;
        case 'white':
            return props.theme.white_base;
        case 'red':
            return props.theme.pink_100;
        default:
            return props.theme.purple_100;
    }
};

const defaultWidth = '70px';
const defaultHeight = '12px';
const defaultDesktopWidth = '116px';
const defaultDesktopHeight = '20px';

export const Logo = styled.svg<LogoProps>`
    display: inline-flex;
    width: ${(props) => props.width ?? defaultWidth};
    height: ${(props) => props.height ?? defaultHeight};
    --accent: ${(props) => getLogoColor(props)};

    ${media.desktop1920} {
        width: ${(props) => props.width ?? defaultDesktopWidth};
        height: ${(props) => props.height ?? defaultDesktopHeight};
    }
`;

type PaysendLogoProps = LogoProps;

export const PaysendLogo: React.FC<PaysendLogoProps> = ({ color, width, height }) => {
    return (
        <Logo color={color} width={width} height={height}>
            <use xlinkHref="/i/svg-icons/icons.svg#paysend-logo" />
        </Logo>
    );
};
